import { useCallback, useState, useEffect } from 'react';

import { listarEmpresaCertificados, testarEmpresaCertificado } from '../../../../api/certificado';

export default function useCertificadoModule({ dados, context, setFlashMessage }) {
    const [loading, setLoading] = useState(false);
    const empresaId = context.empresaId;
    const [rows, setRows] = useState([]);

    // state para armazenar o uuid do certificado que está sendo testado
    const [testingUuid, setTestingUuid] = useState(null);

    const [dialogOpen, setDialogOpen] = useState(false);

    const [selected, setSelected] = useState(null);

    const abrirCadastro = useCallback(() => {
        setSelected(null);
        setDialogOpen(true);
    }, []);

    const abrirEdicao = useCallback((row) => {
        setSelected(row);
        setDialogOpen(true);
    }, []);

    const abrirExclusao = useCallback((row) => {
        setSelected(row);
        setDialogOpen(true);
        // futuramente abrir dialog de confirmação
    }, []);

    const fecharDialog = useCallback(() => {
        setDialogOpen(false);
    }, []);

    const atualizar = useCallback(async () => {
        if (!empresaId) {
            setRows([]);
            return;
        }

        setLoading(true);

        try {
            const response = await listarEmpresaCertificados(empresaId);

            setRows(Array.isArray(response?.resultado) ? response.resultado : []);
        } catch (error) {
            console.error('Erro ao carregar certificados:', error);

            setRows([]);

            setFlashMessage?.(
                error?.response?.data?.message || 'Erro ao carregar certificados.',
                error?.response?.data?.type || 'error'
            );
        } finally {
            setLoading(false);
        }
    }, [empresaId, setFlashMessage]);

    const testar = useCallback(
        async (certificado) => {
            if (!empresaId || !certificado?.uuid) {
                setFlashMessage?.('Certificado não identificado.', 'warning');

                return null;
            }

            setTestingUuid(certificado.uuid);

            try {
                const resultado = await testarEmpresaCertificado({
                    empresaId,
                    uuid: certificado.uuid,
                });

                setFlashMessage?.(resultado?.message || 'Certificado validado com sucesso!', resultado?.type || 'success');

                await atualizar();

                return resultado;
            } catch (error) {
                console.error('Erro ao testar certificado:', error);

                const payload = error?.response?.data;

                setFlashMessage?.(
                    payload?.message || 'O certificado apresentou problemas.',

                    payload?.type || 'error'
                );

                /*
                 * Mesmo quando o teste falha, o backend atualiza
                 * último status e mensagem.
                 */
                await atualizar();

                return null;
            } finally {
                setTestingUuid(null);
            }
        },
        [empresaId, setFlashMessage, atualizar]
    );

    useEffect(() => {
        atualizar();
    }, [atualizar]);

    return {
        state: {
            loading,
            rows,
            dialogOpen,
            selected,
            testingUuid,
        },

        actions: {
            abrirCadastro,
            abrirEdicao,
            abrirExclusao,
            fecharDialog,
            atualizar,
            setRows,
            setSelected,
            testar,
        },
    };
}
